/**
 * Pre-compiled fr-FR messages for ModalPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  backButton: (args: Record<string, string | number>) =>
    `Retourner à ${args.previousPathLabel}`,
};
